import React from 'react';
import { Dialog, DialogContent, Typography, Button, Box } from '@mui/material';

const DeleteSongModal = ({ isOpen, onClose, onConfirm, loading }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 1.5, p: 2, textAlign: 'center' } }}>
      <DialogContent>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
          Please confirm to delete this Song
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
          Once deleted, it will not be available in the mobile application.
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={loading}
            sx={{
              textTransform: 'none',
              borderRadius: 1,
              px: 4,
              py: 1,
              fontWeight: 600,
              backgroundColor: '#2563eb', // Matches blue button from screenshot
              '&:hover': { backgroundColor: '#1d4ed8' },
            }}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              textTransform: 'none',
              borderRadius: 1,
              px: 4,
              py: 1,
              color: '#64748b',
              borderColor: '#cbd5e1',
            }}
          >
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteSongModal;